import React from 'react'
import { useUserLogout } from '../hooks/useUserLogout'
import { Link } from '@ztechapps/webui.util'

export const Logout = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  const onLogout = useUserLogout()

  return (
    <Link
      className={className}
      onClick={async (e) => {
        e.preventDefault()
        await onLogout()
      }}
    >
      {children}
    </Link>
  )
}
